import customButton from './button.vue';

export default customButton;
